const cl = 'https://res.cloudinary.com/dsarxqp57/image/upload/q_auto,f_auto';

export const picture20 = `${cl}/images/10_10.jpg`;
export const picture3 = `${cl}/images/11.jpg`;
export const picture10 = `${cl}/images/111.jpg`;
export const sea = `${cl}/images/12_12.jpg`;
export const picture12 = `${cl}/images/13.jpg`;
export const picture13 = `${cl}/images/13_13.jpg`;
export const picture9 = `${cl}/images/14_14.jpg`;
export const sheep = `${cl}/images/15_15.jpg`;
export const picture16 = `${cl}/images/16.jpg`;
export const picture1 = `${cl}/images/2.jpg`;
export const picture11 = `${cl}/images/22.jpg`;
export const picture14 = `${cl}/images/33.jpg`;
export const picture2 = `${cl}/images/44.jpg`;
export const picture6 = `${cl}/images/55.jpg`;
export const picture8 = `${cl}/images/6.jpg`;
export const picture77 = `${cl}/images/77.jpg`;
export const picture7 = `${cl}/images/88.jpg`;
export const picture4 = `${cl}/images/99.jpg`;
export const about = `${cl}/images/about.jpg`;
export const alina = `${cl}/images/alina.jpg`;
export const alina2 = `${cl}/images/alina2.png`;
export const picture5 = `${cl}/images/bigg.jpg`;
export const bigSea = `${cl}/images/bigsea.jpg`;
export const commissions = `${cl}/images/commissions.jpg`;
export const contact = `${cl}/images/contact.jpg`;
export const grib = `${cl}/images/grib.jpg`;
export const picture15 = `${cl}/images/grib2.png`;
export const logo = `${cl}/images/logo.png`;
export const prints = `${cl}/images/prints.jpg`;
export const sea2 = `${cl}/images/sea2.jpg`;
